import Http from '@/libs/axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    couponList: [],
    coupon: null,
    couponTypeOptions: [],
    couponPrefix: []
  },
  getters: {
    couponList: state => {
      return state.couponList
    },
    couponTypeOptions: state => {
      return state.couponTypeOptions
    },
    couponPrefix: state => {
      return state.couponPrefix
    }
  },
  mutations: {
    SET_COUPON_LIST(state, coupons) {
      state.couponList = coupons
    },
    SET_COUPON(state, coupon){
      state.coupon = coupon
    },
    SET_COUPON_TYPE_OPTIONS(state, coupons){
      state.couponTypeOptions = coupons
    },
    SET_COUPON_PREFIX(state, prefix){
      state.couponPrefix = prefix
    }
  },
  actions: {
    getList({commit}, {params}){
      return new Promise((resolve, reject) => {
        Http.get('coupons', { params: params }).then(response => {
            commit('SET_COUPON_LIST', response.data)
            resolve()
        }).catch(error => reject(error))
      })
    },
    getCouponTypeOptions({commit}){
        return new Promise((resolve, reject) => {
            Http.get('coupons/type-options')
            .then(res => {
              commit('SET_COUPON_TYPE_OPTIONS', res.data)
              resolve()
            })
            .catch(err => reject(err))
        })
    },
    getCouponPrefix({commit}){
      return new Promise((resolve, reject) => {
          Http.get('coupons/all-coupon-prefix')
          .then(res => {
            commit('SET_COUPON_PREFIX', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      });
    },
    create({}, { payload }){
      return new Promise((resolve, reject) => {
          payload.rec_date = moment(payload.rec_date).format('YYYY-MM-DD')
          Http.post('coupons', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    issueToAgent({}, { payload }){
      return new Promise((resolve, reject) => {
          payload.issueDate = moment(payload.issueDate).format('YYYY-MM-DD')
          Http.post('coupons/issue-to-agent', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },    
    returnFromAgent({}, { payload }){
      return new Promise((resolve, reject) => {
          payload.returnDate = moment(payload.returnDate).format('YYYY-MM-DD')
          Http.post('coupons/return-from-agent', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    returnFromPondok({}, { payload }){
      return new Promise((resolve, reject) => {
          payload.returnDate = moment(payload.returnDate).format('YYYY-MM-DD')
          Http.post('coupons/return-from-pondok', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    issueToPondok({}, { payload }){
      return new Promise((resolve, reject) => {
          payload.issueDate = moment(payload.issueDate).format('YYYY-MM-DD')
          Http.post('coupons/issue-to-pondok', payload)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    delete({}, { payload }){
      return new Promise((resolve, reject) => {
          Http.delete('coupons/delete-by-receiving-no/'+ payload.Rec_no)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    deleteSingle({}, { couponNo }){
      return new Promise((resolve, reject) => {
          Http.delete('coupons/'+ couponNo)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    getIssuedInfo({}, data){
      return new Promise((resolve, reject) => {
          Http.post('coupons/issued-info', data)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
    getIssuedNumbers({}, data){
      return new Promise((resolve, reject) => {
          Http.post('coupons/issued-numbers', data)
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
  }
}
